import Seamless from '../../../images/Seamless.png';

export const SeamlessIcon = () => (
  <div className="order-res-links-icon">
    <img src={Seamless} alt="Seamless" />
  </div>
);

export default SeamlessIcon;
